import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const MOCK_MODE = process.env.REACT_APP_MOCK_MODE === "true";

function parseToken() {
  try {
    const token = localStorage.getItem("token");
    if (!token) return null;

    // mock-token is only valid when MOCK_MODE is explicitly enabled
    if (token === "mock-token") {
      if (!MOCK_MODE) return null;
      return { role: localStorage.getItem("mockRole") || null, exp: Infinity };
    }

    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload;
  } catch {
    return null;
  }
}

function isExpired(payload) {
  if (!payload || !payload.exp) return true;
  if (payload.exp === Infinity) return false;
  return payload.exp * 1000 < Date.now();
}

function ProtectedRoute({ children, requiredRole }) {
  const location = useLocation();
  const payload = parseToken();

  if (!payload || isExpired(payload)) {
    localStorage.removeItem("token");
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (requiredRole) {
    const allowed = Array.isArray(requiredRole) ? requiredRole : [requiredRole];
    if (!allowed.includes(payload.role)) {
      return <Navigate to="/" replace />;
    }
  }

  return children;
}

export default ProtectedRoute;
